// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tools"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21.7607 16.8119L16.9063 11.9575C17.699 9.38593 17.0789 6.47326 15.0432 4.43757C12.8445 2.23891 9.62043 1.68993 6.91077 2.79202L6.91146 3.37691L11.1541 7.61955L7.61857 11.1551L3.37593 6.91244L2.79105 6.91175C1.68895 9.6214 2.23793 12.8455 4.43659 15.0442C6.47228 17.0799 9.38496 17.7 11.9565 16.9072L16.811 21.7617M15.75 15.7513L19.2855 19.2868","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ToolsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tools',
    ref,
    icon: element,
  },
));

ToolsIcon.displayName = 'ToolsIcon';

export default ToolsIcon;
